<template>
  <div v-if="user" class="w-full h-full flex flex-col relative">
    <nav
      class="flex justify-between px-6 h-16 fixed left-0 right-0 top-0 z-50 bg-gradient-to-r from-primary-600 to-primary-400 text-white shadow-soft"
    >
      <div class="flex space-x-4 items-center">
        <router-link
          :to="{ name: 'ordersIndex' }"
          class="button-interactive hover:opacity-75"
        >
          <white-logo-icon class="w-20" />
        </router-link>

        <button
          class="rounded-full w-6 h-6 button-interactive flex-shrink-0"
          @click="collapsed = !collapsed"
        >
          <menu-icon class="w-full stroke-current fill-current" />
        </button>

        <!-- <div
          v-if="hasPermission('view_notifications')"
          class="flex items-center relative button-interactive cursor-pointer"
          @mouseover="showFranchiseMenu = true"
          @mouseleave="showFranchiseMenu = false"
        >
          <p>{{ user.franchise_user.franchise.name }}</p>

          <arrow-icon class="ml-2 w-2 text-white fill-current"></arrow-icon>

          <div
            v-if="showFranchiseMenu"
            class="flex flex-col rounded bg-white absolute left-0 top-[20px] shadow z-50 text-content-500"
          >
  
            <router-link
              :to="{ name: 'franchiseReports' }"
              :class="[
                'flex items-center justify-center w-full px-4 h-10 text-sm whitespace-nowrap smooth',
                {
                  'bg-primary-100 text-primary-500':
                    selectedTab === 'franchiseReports',
                },
                {
                  'bg-primary-100 text-primary-500':
                    franchiseMenuAction === 'franchiseReports',
                },
              ]"
              @mouseover="franchiseMenuAction = 'franchiseReports'"
              @mouseleave="franchiseMenuAction = null"
              @click.native="showFranchiseMenu = false"
            >
              Reportes
            </router-link>
          </div>
        </div>

        <p v-else>{{ user.franchise_user.franchise.name }}</p> -->
        <router-link
          v-if="hasPermission('view_franchise')"
          :to="{ name: 'franchiseDetail' }"
          class="underline"
          >{{ user.franchise_user.franchise.name }}</router-link
        >
        <p v-else>{{ user.franchise_user.franchise.name }}</p>
      </div>

      <div class="flex items-center space-x-6">
        <router-link
          v-if="hasPermission('view_notifications')"
          :to="{ name: 'notifications' }"
          class="button-interactive rounded-full items-center flex hover:opacity-80"
          :class="[{ 'text-success-500': selectedTab === 'notifications' }]"
        >
          <p
            v-if="branchNotifications > 0"
            class="text-success-500 font-medium"
          >
            {{ branchNotifications }}
          </p>
          <bell-icon class="w-6 h-6 stroke-current" />
        </router-link>

        <router-link
          v-if="currentBranch.id !== 1"
          :to="{ name: 'productsIndex' }"
          class="button-interactive items-center flex"
          :class="{ 'text-success-500': selectedTab === 'products' }"
        >
          <store-icon class="w-5 h-5 fill-current mx-auto" />
        </router-link>

        <router-link
          v-if="currentBranch.id !== 1"
          :to="{ name: 'cart' }"
          class="button-interactive items-center flex"
          :class="{ 'text-success-500': selectedTab === 'cart' }"
        >
          <p
            v-if="cart.products.length > 0"
            class="text-success-500 font-medium"
          >
            {{ cart.products.length }}
          </p>
          <cart-icon class="w-5 h-5 fill-current mx-auto" />
        </router-link>

        <div class="flex flex-col">
          <p class="text-xs text-right font-medium">
            {{ user.email }}
          </p>
          <div class="w-full flex justify-end mt-1">
            <button
              class="text-xs w-fit button-interactive"
              @click="$store.dispatch('logout')"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    </nav>
    <div class="flex w-full h-full pt-16 relative">
      <div
        class="flex flex-col flex-shrink-0 h-full py-4 fixed sm:static bg-white border-r border-primary-100 tabSlider z-40 overflow-auto"
        :class="[{ 'w-[220px] px-4': !collapsed }, { 'w-0': collapsed }]"
      >
        <transition name="tabs">
          <div v-show="!collapsed" class="flex flex-col">
            <!-- <router-link
              :to="{ name: 'ordersIndex' }"
              class="button-interactive hover:opacity-75 mx-auto"
            >
              <logo-icon class="w-20" />
            </router-link> -->

            <h2 class="mt-2" v-if="branches.length === 1">
              {{ branches[0].name }}
            </h2>

            <custom-select
              v-else
              class="my-2"
              v-model="selectedBranchId"
              :options="getBranchOptions()"
              @change="selectBranch"
            />

            <router-link
              :to="{ name: 'profileDetail' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'profile' }]"
            >
              <div v-show="selectedTab === 'profile'" class="tabSelector"></div>
              <div class="flex items-center">
                <branch-icon class="w-4 fill-current mr-2" />
                <span>Sucursal</span>
              </div>
            </router-link>

            <!-- <router-link
              v-if="hasPermission('view_notifications')"
              :to="{ name: 'notifications' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'notifications' }]"
              @click.prevent="$store.dispatch('emptyBreadcrumbs')"
            >
              <div
                v-show="selectedTab === 'notifications'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <bell-icon class="w-4 fill-current mr-2" />
                <span>Notificationes</span>
              </div>
            </router-link> -->

            <router-link
              v-if="hasPermission('view_ranges')"
              :to="{ name: 'rangesIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'ranges' }]"
            >
              <div v-show="selectedTab === 'ranges'" class="tabSelector"></div>
              <div class="flex items-center">
                <ranges-icon class="w-4 fill-current mr-2" />
                <span>Rangos de envío</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_orders')"
              :to="{ name: 'ordersIndex', query: { status: 'pending' } }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'orders' }]"
            >
              <div v-show="selectedTab === 'orders'" class="tabSelector"></div>
              <div class="flex items-center">
                <orders-icon class="w-4 fill-current mr-2" />
                <span>Órdenes</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_quotes')"
              :to="{ name: 'quotesIndex', query: { status: 'active' } }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'quotes' }]"
            >
              <div v-show="selectedTab === 'quotes'" class="tabSelector"></div>
              <div class="flex items-center">
                <quote-requests-icon class="w-4 fill-current mr-2" />
                <span>Planes</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_orders')"
              :to="{ name: 'productionScheduleIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'productionSchedule' }]"
            >
              <div v-show="selectedTab === 'productionSchedule'" class="tabSelector"></div>
              <div class="flex items-center">
                <orders-icon class="w-4 fill-current mr-2" />
                <span>Programa Produccion</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_order_requests')"
              :to="{ name: 'orderRequestsIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'orderRequests' }]"
            >
              <div
                v-show="selectedTab === 'orderRequests'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <quote-requests-icon class="w-4 fill-current mr-2" />
                <span>Solicitudes de adelanto</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_inventories')"
              :to="{ name: 'inventoriesIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'inventories' }]"
            >
              <div
                v-show="selectedTab === 'inventories'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <inventory-icon class="w-4 fill-current mr-2" />
                <span>Inventario</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_clients')"
              :to="{ name: 'clientsIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'clients' }]"
            >
              <div v-show="selectedTab === 'clients'" class="tabSelector"></div>
              <div class="flex items-center">
                <clients-icon class="w-4 fill-current mr-2" />
                <span>Clientes</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_pets')"
              :to="{ name: 'petsIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'pets' }]"
            >
              <div v-show="selectedTab === 'pets'" class="tabSelector"></div>
              <div class="flex items-center">
                <pets-icon class="w-4 fill-current mr-2" />
                <span>Mascotas</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_users')"
              :to="{ name: 'usersIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'users' }]"
            >
              <div v-show="selectedTab === 'users'" class="tabSelector"></div>
              <div class="flex items-center">
                <users-icon class="w-4 fill-current mr-2" />
                <span>Usuarios</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_roles')"
              :to="{ name: 'rolesIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'roles' }]"
            >
              <div v-show="selectedTab === 'roles'" class="tabSelector"></div>
              <div class="flex items-center">
                <roles-icon class="w-4 fill-current mr-2" />
                <span>Roles</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_product_orders')"
              :to="{ name: 'productOrders' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'productOrders' }]"
            >
              <div
                v-show="selectedTab === 'productOrders'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <orders-icon class="w-4 fill-current mr-2" />
                <span>Órdenes de Compra</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_accounting')"
              :to="{ name: 'accounting' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'accounting' }]"
            >
              <div
                v-show="selectedTab === 'accounting'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <accounting-icon class="w-4 fill-current mr-2" />
                <span>Contabilidad</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_reports')"
              :to="{ name: 'biweekly' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'reports' }]"
            >
              <div v-show="selectedTab === 'reports'" class="tabSelector"></div>
              <div class="flex items-center">
                <reports-icon class="w-4 fill-current mr-2" />
                <span>Reportes</span>
              </div>
            </router-link>

            <router-link
              :to="{ name: 'manual' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'manual' }]"
            >
              <div v-show="selectedTab === 'manual'" class="tabSelector"></div>
              <div class="flex items-center">
                <manual-icon class="w-4 fill-current mr-2" />
                <span>Ayuda</span>
              </div>
            </router-link>
          </div>
        </transition>
      </div>

      <div class="flex-auto overflow-auto bg-background p-8">
        <app-breadcrumbs />
        <router-view class="" />
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumbs from "@/components/AppBreadcrumbs";
import LogoIcon from "@/icons/LogoIcon";
import WhiteLogoIcon from "@/icons/WhiteLogoIcon";
import BellIcon from "@/icons/BellIcon";
import StoreIcon from "@/icons/StoreIcon";
import CartIcon from "@/icons/CartIcon";
import AccountIcon from "@/icons/AccountIcon";
import MenuIcon from "@/icons/MenuIcon";
import ArrowIcon from "@/icons/ArrowIcon";
import PetsIcon from "@/icons/PetsIcon";
import BranchIcon from "@/icons/BranchIcon";
import RangesIcon from "@/icons/RangesIcon";
import OrdersIcon from "@/icons/OrdersIcon";
import InventoryIcon from "@/icons/InventoryIcon";
import ClientsIcon from "@/icons/ClientsIcon";
import QuoteRequestsIcon from "@/icons/QuoteRequestsIcon";
import UsersIcon from "@/icons/UsersIcon";
import RolesIcon from "@/icons/RolesIcon";
import AccountingIcon from "@/icons/AccountingIcon";
import ReportsIcon from "@/icons/ReportsIcon";
import ManualIcon from "@/icons/ManualIcon";
import { mapState } from "vuex";
export default {
  name: "Dashboard",

  components: {
    AppBreadcrumbs,
    LogoIcon,
    WhiteLogoIcon,
    BellIcon,
    StoreIcon,
    CartIcon,
    AccountIcon,
    MenuIcon,
    ArrowIcon,
    PetsIcon,
    BranchIcon,
    RangesIcon,
    OrdersIcon,
    QuoteRequestsIcon,
    InventoryIcon,
    ClientsIcon,
    UsersIcon,
    RolesIcon,
    AccountingIcon,
    ReportsIcon,
    ManualIcon
  },

  data() {
    return {
      collapsed: false,
      selectedBranchId: null,
      showFranchiseMenu: false,
      franchiseMenuAction: null,
    };
  },

  computed: {
    ...mapState({
      user: "user",
      cart: "cart",
      branches: "branches",
      selectedTab: "selectedTab",
    }),

    currentBranch() {
      return this.branches.filter(
        (branch) => branch.id == this.$route.params.branchId
      )[0];
    },

    branchNotifications() {
      if (!this.currentBranch) {
        return null;
      }

      return this.currentBranch.pending_notifications_count;
    },
  },

  mounted() {
    this.selectedBranchId = this.$route.params.branchId;
  },

  methods: {
    getBranchOptions() {
      const options = [];

      this.branches.forEach((branch) => {
        options.push({
          value: `${branch.id}`,
          label: branch.name,
        });
      });

      return options;
    },

    selectBranch() {
      this.$router.push({
        name: "dashboard",
        params: { branchId: this.selectedBranchId },
      });
    },
  },
};
</script>

<style scoped>
.tabSlider {
  @apply transition-all transform duration-500 ease-in-out;
}

.tab {
  @apply my-1 py-1 pl-2 rounded-r-full;
}

.tabSelector {
  @apply absolute -left-4 top-0 right-0 bottom-0 bg-primary-100 rounded-r-full -z-10;
}

.tabs-enter-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
  transition-delay: 0.2s;
}

.tabs-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.tabs-enter-from,
.tabs-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.tabs-enter-to,
.tabs-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.subTabs-enter-active,
.subTabs-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.subTabs-enter-from,
.subTabs-leave-to {
  opacity: 0;
  transform: translateY(-10px); /* Adjust the value as needed */
}

.subTabs-enter-to,
.subTabs-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>